import React, { useEffect } from 'react';
import feather from 'feather-icons';
import { useLanguage } from '../../context/LanguageContext';

const AuthHeader = () => {
    useEffect(() => {
        feather.replace();
    }, []);
    const { t } = useLanguage();

    return (
        <div className="auth-header">
            <img className="img-fluid img" src={'assets/images/authentication/1.svg'} alt="v1" />
            <div className="auth-content">
                <div>
                    <h2>{t('loginWelcome')}</h2>
                    <h4 className="p-0">{t('loginSubtitle')}</h4>
                </div>
            </div>
        </div>
    );
};

export default AuthHeader;
